var map = {
	"./1.png": 7644,
	"./10.png": 2361,
	"./11.png": 9520,
	"./12.png": 9005,
	"./13.png": 3257,
	"./14.png": 3438,
	"./2.png": 4567,
	"./3.png": 3808,
	"./4.png": 2945,
	"./5.png": 6738,
	"./6.png": 9803,
	"./7.png": 8956,
	"./8.png": 5719,
	"./9.png": 4945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4389;